/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomTextV1Dto } from './CustomTextV1Dto';
import type { FieldCheckboxCreateV1Dto } from './FieldCheckboxCreateV1Dto';
import type { FieldMentionCreateV1Dto } from './FieldMentionCreateV1Dto';
import type { FieldRadioGroupCreateV1Dto } from './FieldRadioGroupCreateV1Dto';
import type { FieldSignatureCreateV1Dto } from './FieldSignatureCreateV1Dto';
import type { FieldTextCreateV1Dto } from './FieldTextCreateV1Dto';
import type { RedirectUrlsV1Dto } from './RedirectUrlsV1Dto';
import type { TemplateInfoV1Dto } from './TemplateInfoV1Dto';
export type SignerFromScratchCreateV1Dto = {
  /**
   * The custom text of the template
   */
  custom_text?: CustomTextV1Dto;
  /**
   * The delivery mode of the template
   */
  delivery_mode?: SignerFromScratchCreateV1Dto.delivery_mode;
  /**
   * The redirect urls of the template
   */
  redirect_urls?: RedirectUrlsV1Dto;
  /**
   * The level of the signature
   */
  signature_level?: SignerFromScratchCreateV1Dto.signature_level;
  /**
   * The signature authentication mode
   */
  signature_authentication_mode?: SignerFromScratchCreateV1Dto.signature_authentication_mode | null;
  /**
   * Fields assigned to the signer
   */
  fields: Array<
    | FieldSignatureCreateV1Dto
    | FieldTextCreateV1Dto
    | FieldMentionCreateV1Dto
    | FieldCheckboxCreateV1Dto
    | FieldRadioGroupCreateV1Dto
  > | null;
  /**
   * The info of the template
   */
  info: TemplateInfoV1Dto;
};
export namespace SignerFromScratchCreateV1Dto {
  /**
   * The delivery mode of the template
   */
  export enum delivery_mode {
    EMAIL = 'email',
    NONE = 'none',
  }
  /**
   * The level of the signature
   */
  export enum signature_level {
    ELECTRONIC_SIGNATURE = 'electronic_signature',
    ADVANCED_ELECTRONIC_SIGNATURE = 'advanced_electronic_signature',
    QUALIFIED_ELECTRONIC_SIGNATURE = 'qualified_electronic_signature',
  }
  /**
   * The signature authentication mode
   */
  export enum signature_authentication_mode {
    OTP_EMAIL = 'otp_email',
    OTP_SMS = 'otp_sms',
    NO_OTP = 'no_otp',
  }
}
